import FAQ from "../../../components/faq/FAQ";

export default function EventFaq() {
    return <>{<FAQ entries={
        [
            {
                headline: 'Zahlungsoptionen',
                body: <p>Ihr habt die Möglichkeit per Kreditkarte, Sofortüberweisung oder PayPal-Konto zu bezahlen.</p>
            },
            {
                headline: 'Buchung und Stornierung',
                body: <p>
                    Eine Stornierung des Tickets ist nach Bestellabschluss nicht mehr möglich.
                    <br /> <br />
                    Nach der Bestellung bekommst Du Deine Eventtickets sofort per Mail zugeschickt. Bitte gebe dieses nicht weiter, da das Ticket nur einmal am entsprechenden Veranstaltungstag eingelöst werden kann und danach die Gültigkeit verliert.
                    <br />
                    Um Betrugsversuche zu vermeiden, kann bei Falschangabe der E-Mail-Adresse das Eventticket nicht erneut versendet werden.
                    <br /><br />
                    Sollte es zu einer Absage der Veranstaltung kommen, wird das Ticket in voller Höhe erstattet.
                </p>
            }
        ]
    } />}</>
}